/**
 * The name of the query parameter that Google adds to the URL for navigations
 * from Google Appointments
 */
export const GOOGLE_APPOINTMENTS_CONVERSTION_PARAM = "rwg_token";
